import firebase from "@/firebase"

const state = {
    selectedSession: null,
    selectedProject: null,
};

const getters = {
    selectedSession: (state) => state.selectedSession,
    selectedProject: (state) => state.selectedProject,
};

const mutations = {
    SET_SELECTED_SESSION(state, session) {
        state.selectedSession = session;
    },
    SET_SELECTED_PROJECT(state, project) {
        state.selectedProject = project;
    },
    REMOVE_PROJECT_MEMBER(state, memberId) {
        if (state.selectedProject && state.selectedProject.members) {
            state.selectedProject.members = state.selectedProject.members.filter(member => member.id !== memberId);
        }
    },
    ADD_PROJECT_MEMBERS(state, newMembers) {
        if (state.selectedProject && state.selectedProject.members) {
            state.selectedProject.members = [...state.selectedProject.members, ...newMembers];
        }
    }
};

const actions = {
    setSelectedSession({ commit }, session) {
        commit('SET_SELECTED_SESSION', session);
    },
    setSelectedProject({ commit }, project) {
        commit('SET_SELECTED_PROJECT', project);
    },
    async removeProjectMember({ commit, state }, member) {
        try {
            const projectRef = firebase.firestore().collection("ai/collective/projects").doc(state.selectedProject.id);
            await projectRef.update({
                members: firebase.firestore.FieldValue.arrayRemove(member)
            });
            commit('REMOVE_PROJECT_MEMBER', member.id);
        } catch (error) {
            console.error('Error removing project member:', error);
            throw error;
        }
    },
    async addProjectMembers({ commit, state }, newMembers) {
        try {
            const projectRef = firebase.firestore().collection("ai/collective/projects").doc(state.selectedProject.id);
            await projectRef.update({
                members: firebase.firestore.FieldValue.arrayUnion(...newMembers)
            });
            commit('ADD_PROJECT_MEMBERS', newMembers);
        } catch (error) {
            console.error('Error adding project members:', error);
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
